// Translations for all supported languages
export const translations = {
  en: {
    title: "Ask Lenny",
    welcome: "Hi, I'm Lenny",
    subtitle: "Type your question below, or talk by voice.",
    buttonLabel: "Chat with Lenny",
    hint: "Speak naturally - I'll understand!",
    textHint: "Type your question, or tap \"Talk to Lenny by voice\".",
    speechBubble: "Ask me anything!",
    retry: "Try Again",
    status: {
      connected: "Connected",
      connecting: "Connecting...",
      disconnected: "Disconnected",
      error: "Error"
    },
    error: {
      failed: "Connection failed",
      retry: "Try Again",
      browserNotSupported: "Your browser doesn't support voice features. Please open this site in Chrome, Safari, or Firefox for full functionality.",
      gmailBrowser: "Voice features are not available in Gmail's in-app browser. Please open this link in Chrome or Safari for the best experience.",
      microphoneError: "Microphone access is required. Please check your browser permissions and try again."
    },
    loading: "Connecting to voice agent..."
  },
  zh: {
    title: "食品事实语音助手",
    welcome: "欢迎！",
    subtitle: "问我们任何问题",
    hint: "自然说话 - 我会理解的！",
    speechBubble: "问我任何问题！",
    retry: "重试",
    status: {
      connected: "已连接",
      connecting: "连接中...",
      disconnected: "未连接",
      error: "错误"
    },
    error: {
      failed: "连接失败",
      retry: "重试",
      browserNotSupported: "您的浏览器不支持语音功能。请在 Chrome、Safari 或 Firefox 中打开此网站以获得完整功能。",
      gmailBrowser: "Gmail 应用内浏览器不支持语音功能。请在 Chrome 或 Safari 中打开此链接以获得最佳体验。",
      microphoneError: "需要麦克风访问权限。请检查您的浏览器权限并重试。"
    },
    loading: "正在连接语音助手..."
  },
  de: {
    title: "Food Facts Sprachassistent",
    welcome: "Willkommen!",
    subtitle: "Stellen Sie uns jede Frage",
    hint: "Sprechen Sie natürlich - ich verstehe Sie!",
    speechBubble: "Fragen Sie mich alles!",
    retry: "Erneut versuchen",
    status: {
      connected: "Verbunden",
      connecting: "Verbinden...",
      disconnected: "Getrennt",
      error: "Fehler"
    },
    error: {
      failed: "Verbindung fehlgeschlagen",
      retry: "Erneut versuchen",
      browserNotSupported: "Ihr Browser unterstützt keine Sprachfunktionen. Bitte öffnen Sie diese Website in Chrome, Safari oder Firefox für vollständige Funktionalität.",
      gmailBrowser: "Sprachfunktionen sind im Gmail-In-App-Browser nicht verfügbar. Bitte öffnen Sie diesen Link in Chrome oder Safari für das beste Erlebnis.",
      microphoneError: "Mikrofonzugriff ist erforderlich. Bitte überprüfen Sie Ihre Browserberechtigungen und versuchen Sie es erneut."
    },
    loading: "Verbinde mit Sprachassistent..."
  },
  hi: {
    title: "फूड फैक्ट्स वॉयस असिस्टेंट",
    welcome: "स्वागत है!",
    subtitle: "हमसे कोई भी सवाल पूछें",
    hint: "स्वाभाविक रूप से बोलें - मैं समझ जाऊंगा!",
    speechBubble: "मुझसे कोई भी सवाल पूछें!",
    retry: "पुनः प्रयास करें",
    status: {
      connected: "जुड़ा हुआ",
      connecting: "जुड़ रहा है...",
      disconnected: "डिस्कनेक्ट",
      error: "त्रुटि"
    },
    error: {
      failed: "कनेक्शन विफल",
      retry: "पुनः प्रयास करें",
      browserNotSupported: "आपका ब्राउज़र वॉयस फीचर्स को सपोर्ट नहीं करता। पूर्ण कार्यक्षमता के लिए कृपया Chrome, Safari या Firefox में यह साइट खोलें।",
      gmailBrowser: "Gmail के इन-ऐप ब्राउज़र में वॉयस फीचर्स उपलब्ध नहीं हैं। सर्वोत्तम अनुभव के लिए कृपया Chrome या Safari में यह लिंक खोलें।",
      microphoneError: "माइक्रोफोन एक्सेस आवश्यक है। कृपया अपनी ब्राउज़र अनुमतियों की जांच करें और फिर से प्रयास करें।"
    },
    loading: "वॉयस एजेंट से जुड़ रहा है..."
  },
  es: {
    title: "Asistente de Voz de Food Facts",
    welcome: "¡Bienvenido!",
    subtitle: "Háganos cualquier pregunta",
    hint: "Habla naturalmente - ¡Te entenderé!",
    speechBubble: "¡Hazme cualquier pregunta!",
    retry: "Intentar de nuevo",
    status: {
      connected: "Conectado",
      connecting: "Conectando...",
      disconnected: "Desconectado",
      error: "Error"
    },
    error: {
      failed: "Conexión fallida",
      retry: "Intentar de nuevo",
      browserNotSupported: "Tu navegador no admite funciones de voz. Abre este sitio en Chrome, Safari o Firefox para obtener funcionalidad completa.",
      gmailBrowser: "Las funciones de voz no están disponibles en el navegador integrado de Gmail. Abre este enlace en Chrome o Safari para la mejor experiencia.",
      microphoneError: "Se requiere acceso al micrófono. Verifica los permisos de tu navegador e intenta de nuevo."
    },
    loading: "Conectando al asistente de voz..."
  }
};
